import {
  Button,
  Form,
  Input,
  Spin,
} from "antd";
import React from "react";
import ReactMarkdown from "react-markdown";
import { useState, useEffect } from "react";
import useFetch from "../../hooks/useFetch";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/cartReducer";
import { addToWishlist } from "../../redux/wishlistReducer";
import { API } from "../../constant";

const Product = () => {
  const id = useParams().id;
  const navigate = useNavigate();
  const uplURL = process.env.REACT_APP_UPLOAD_URL;
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [filedata, setFiledata] = useState({filename: "", id: "0"});
  const [selectedImg, setSelectedImg] = useState("");
  const [selectedList, setSelectedList] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const wishes = useSelector((state) => state.wishlist.products);

  const dispatch = useDispatch();
  const { data, loading, error } = useFetch(`/products/${id}?populate=*`, 'NoToken');
  const groups = [];
  if (data?.img) {
    for (let i = 0; i < data.img.length; i += 3) {
      groups.push(data.img.slice(i, i + 3));
    }
  }
  useEffect(() => {
    wishes?.find((item) => item.id === data?.id) ? setSelectedList(true) : setSelectedList(false)
  }, [data, wishes]);

  const onFinish = async (event) => {
    setIsLoading(true);
    try {
      if (file != null) {
        const formData = new FormData();
        formData.append("image", file);
        formData.append("orderId", "0");
        const response = await fetch(`${API}/orderImage`, {
          method: "POST",
          headers: {
            //"Authorization": "Bearer " + getToken(),
            //"content-type": "multipart/form-data"
          },
          body: formData,
        });

        const data = await response.json();
        if (data?.error) {
          console.log(data?.message);
        } else {
          if (data?.success) {
            setFiledata(data);
          }
        }
      } else {
        alert("Please select a file");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="bg-light">
        <div className="container pb-5">
          {loading ? 
            "loading"
           : error ? 
            ( navigate("/404", { replace: true }) )
           :
           (
            <div className="row">
                <div className="col-lg-5 mt-5">
                    <div className="card mb-3">
                        <img className="card-img img-fluid img-full" id="product-detail" src={
                            selectedImg === "" ? 
                            uplURL + data?.img[0]?.image : 
                            uplURL + data?.img?.filter(img => img.id === selectedImg)[0].image
                          } alt="" />
                    </div>
                    <div className="row">
                        {/*Start Controls*/}
                        <div className="col-1 align-self-center">
                            <a href="#multi-item-example" role="button" data-bs-slide="prev">
                                <i className="text-dark fas fa-chevron-left"></i>
                                <span className="sr-only">Previous</span>
                            </a>
                        </div>
                        {/*End Controls*/}
                        {/*Start Carousel Wrapper*/}
                        <div id="multi-item-example" className="col-10 carousel slide carousel-multi-item" data-bs-ride="carousel">
                            {/*Start Slides*/}
                            <div className="carousel-inner product-links-wap" role="listbox">
                              {groups?.map((group, groupIndex) => {
                                return (
                                <div key={groupIndex} className={`carousel-item ${groupIndex === 0 ? "active" : ""}`}>
                                  <div className="row">
                                    {group.map(img => {
                                      return (
                                      <div className="col-4 item" key={img.id}>
                                        <Link to="#">
                                          <img className="card-img img-fluid img-thumbnail" alt={img.title} src={uplURL + img.image} onClick={(e) => setSelectedImg(img.id)} />
                                        </Link>
                                      </div>)
                                    })}
                                  </div>
                                </div>)
                              })}
                            </div>
                            {/*End Slides*/}
                        </div>
                        {/*End Carousel Wrapper*/}
                        {/*Start Controls*/}
                        <div className="col-1 align-self-center">
                            <a href="#multi-item-example" role="button" data-bs-slide="next">
                                <i className="text-dark fas fa-chevron-right"></i>
                                <span className="sr-only">Next</span>
                            </a>
                        </div>
                        {/*End Controls*/}
                    </div>
                </div>
                {/* col end */}
                <div className="col-lg-7 mt-5">
                    <div className="card">
                        <div className="card-body">
                            <h1 className="h2 product-title">{data?.title}</h1>
                            <p className="h3 py-2">₹{data?.price}</p>
                            
                            <h6 className="text-dark">Description:</h6>
                            <p><ReactMarkdown>{data?.description}</ReactMarkdown></p>
                            {/*
                            <p className="py-2">
                                <i className="fa fa-star text-warning"></i>
                                <i className="fa fa-star text-warning"></i>
                                <i className="fa fa-star text-warning"></i>
                                <i className="fa fa-star text-warning"></i>
                                <i className="fa fa-star text-secondary"></i>
                                <span className="list-inline-item text-dark">Rating 4.8 | 36 Comments</span>
                            </p>
                            <ul className="list-inline">
                                <li className="list-inline-item">
                                    <h6>Brand:</h6>
                                </li>
                                <li className="list-inline-item">
                                    <p className="text-muted"><strong>Easy Wear</strong></p>
                                </li>
                            </ul>
                            <ul className="list-inline">
                                <li className="list-inline-item">
                                    <h6>Avaliable Color :</h6>
                                </li>
                                <li className="list-inline-item">
                                    <p className="text-muted"><strong>White / Black</strong></p>
                                </li>
                            </ul>

                            <h6>Specification:</h6>
                            <ul className="list-unstyled pb-3">
                                <li>Lorem ipsum dolor sit</li>
                                <li>Amet, consectetur</li>
                                <li>Adipiscing elit,set</li>
                                <li>Duis aute irure</li>
                                <li>Ut enim ad minim</li>
                                <li>Dolore magna aliqua</li>
                                <li>Excepteur sint</li>
                            </ul>*/}

                            <div className="row">
                                {/*<div className="col-auto">
                                    <ul className="list-inline pb-3">
                                        <li className="list-inline-item">Size :
                                            <input type="hidden" name="product-size" id="product-size" value="S"/>
                                        </li>
                                        <li className="list-inline-item"><span className="btn btn-success btn-size">S</span></li>
                                        <li className="list-inline-item"><span className="btn btn-success btn-size">M</span></li>
                                        <li className="list-inline-item"><span className="btn btn-success btn-size">L</span></li>
                                        <li className="list-inline-item"><span className="btn btn-success btn-size">XL</span></li>
                                    </ul>
                                </div>*/}
                                <div className="col-auto">
                                    <ul className="list-inline pb-3">
                                        <li className="list-inline-item text-right">
                                            Quantity
                                            <input type="hidden" name="product-quanity" id="product-quanity" value="1"/>
                                        </li>
                                        <li className="list-inline-item"><button onClick={() => setQuantity((prev) => (prev === 1 ? 1 : prev - 1)) } className="btn btn-success">-</button></li>
                                        <li className="list-inline-item"><span className="badge bg-secondary" id="var-value">{quantity}</span></li>
                                        <li className="list-inline-item"><button onClick={() => setQuantity((prev) => prev + 1)} className="btn btn-success">+</button></li>
                                    </ul>
                                </div>
                            </div>
                            {filedata.filename === "" ? (
                              <Form
                                className="card-body"
                                name="msgOrImg"
                                onFinish={onFinish}
                                layout="vertical"
                                autoComplete="off"
                              >
                                {data?.isMsgReq ? (
                                  <Form.Item
                                    label="Personal Message on Product"
                                    name="msgOnProduct"
                                    rules={[
                                      {
                                        required: true,
                                        type: "string",
                                      },
                                    ]}
                                  >
                                    <Input placeholder="Personalized Message on this product" 
                                      onChange={(e) => setMessage(e.target.value)} value={message} />
                                  </Form.Item>  
                                ) : null}
                                {data?.isImgReq ? (
                                  <>
                                    <Form.Item
                                      label="Personalized Image on Product"
                                      name="imgOnProduct"
                                      rules={[
                                        {
                                          required: true,
                                          type: "string",
                                        },
                                      ]}
                                    >
                                      <Input type="file" onChange={(e) => setFile(e.target.files[0])} />
                                    </Form.Item>
                                    <Form.Item>
                                      <Button
                                        type="primary"
                                        htmlType="submit"
                                        className="login_submit_btn"
                                      >
                                        Upload {isLoading && <Spin size="small" />}
                                      </Button>
                                    </Form.Item>
                                  </>
                                ) : null}
                              </Form>
                            ) : (<img src={uplURL + filedata.filename} className="img-thumbnail me-3 mb-3" />)}
                            <div className="row pb-3">
                                <div className="col d-grid">
                                  <button className="btn btn-success btn-lg" onClick={() => {
                                    dispatch(
                                      (data.isMsgReq || data.isImgReq) ? (filedata.filename !== "" || message !== "") ?
                                      addToWishlist({
                                        id: data.id,
                                        title: data.title,
                                        title_slug: data.title_slug,
                                        description: data.description,
                                        price: data.price,
                                        img: data.img[0].image,
                                        quantity: 1,
                                        file: filedata.filename,
                                        fileId: filedata.id,
                                        message,
                                      }) : alert("Please upload an image or write a message") :
                                      addToWishlist({
                                        id: data.id,
                                        title: data.title,
                                        title_slug: data.title_slug,
                                        description: data.description,
                                        price: data.price,
                                        img: data.img[0].image,
                                        quantity: 1,
                                        file: "",
                                        fileId: "0",
                                        message: ""
                                      })
                                    );
                                    setSelectedList(true);
                                  }}
                                  >{!selectedList ? <i className="far fa-heart text-light" /> : <i className="far fa-heart text-dark" />} ADD TO WISH LIST</button>
                                </div>
                                <div className="col d-grid">
                                  <button
                                    className="btn btn-success btn-lg" onClick={() =>
                                      dispatch(
                                        (data.isMsgReq || data.isImgReq) ? (filedata.filename !== "" || message !== "") ?
                                        addToCart({
                                          id: data.id,
                                          title: data.title,
                                          title_slug: data.title_slug,
                                          description: data.description,
                                          price: data.price,
                                          img: data.img[0].image,
                                          quantity,
                                          file: filedata.filename,
                                          fileId: filedata.id,
                                          message,
                                        }) : alert("Please upload an image or write a message") : 
                                        addToCart({
                                          id: data.id,
                                          title: data.title,
                                          title_slug: data.title_slug,
                                          description: data.description,
                                          price: data.price,
                                          img: data.img[0].image,
                                          quantity,
                                          file: "",
                                          fileId: "0",
                                          message: ""
                                        })
                                      ) && navigate("/cart", { replace: true }
                                      )}
                                  ><i className="fas fa-cart-plus" /> ADD TO CART</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-5">
                  <div className="card">
                    <div className="card-body">
                      <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item" role="presentation">
                          <a class="nav-link active" id="simple-tab-0" data-bs-toggle="tab" href="#simple-tabpanel-0" role="tab" aria-controls="simple-tabpanel-0" aria-selected="true">
                            Description
                          </a>
                        </li>
                        {data?.features ? (
                        <li class="nav-item" role="presentation">
                          <a class="nav-link" id="simple-tab-1" data-bs-toggle="tab" href="#simple-tabpanel-1" role="tab" aria-controls="simple-tabpanel-1" aria-selected="false">
                            Features
                          </a>
                        </li>
                        ) : null}
                        {data?.other_details ? (
                        <li class="nav-item" role="presentation">
                          <a class="nav-link" id="simple-tab-2" data-bs-toggle="tab" href="#simple-tabpanel-2" role="tab" aria-controls="simple-tabpanel-2" aria-selected="false">
                            Other Details
                          </a>
                        </li>
                        ) : null}
                      </ul>
                      <div class="tab-content pt-3" id="tab-content">
                        <div class="tab-pane active" id="simple-tabpanel-0" role="tabpanel" aria-labelledby="simple-tab-0">
                          <ReactMarkdown>{data?.detailed_desc}</ReactMarkdown>
                        </div>
                        {data?.features ? (
                        <div class="tab-pane" id="simple-tabpanel-1" role="tabpanel" aria-labelledby="simple-tab-1">
                          <ReactMarkdown>{data?.features}</ReactMarkdown>
                        </div>
                        ) : null}
                        {data?.other_details ? (
                        <div class="tab-pane" id="simple-tabpanel-2" role="tabpanel" aria-labelledby="simple-tab-2">
                          <ReactMarkdown>{data?.other_details}</ReactMarkdown>
                        </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          )}
        </div>
    </section>
  );
};

export default Product;